<div class="mat-table-container">
  <mat-card-title class="mat-card-title">
    <mat-toolbar class="mat-tool-bar">
      Diagnostics - Scans
      <span class="subtitle"><i>Session ID:</i> {{sessionId}}</span>
      <mat-form-field id="filter-container" floatPlaceholder="never">
        <input id="filter-input" matInput type="text" (keyup)="doFilter($event.target.value)" placeholder="Filter">
      </mat-form-field>
    </mat-toolbar>
  </mat-card-title>

  <mat-table [dataSource]="scansDataSource" matSort>
    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
      <mat-cell *matCellDef="let scan">{{scan.status}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="error">
      <mat-header-cell *matHeaderCellDef>Error</mat-header-cell>
      <mat-cell *matCellDef="let scan">
        {{scan.error}}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="completedAt">
      <mat-header-cell *matHeaderCellDef>completed</mat-header-cell>
      <mat-cell *matCellDef="let scan">{{scan.completedAt | date}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="client">
      <mat-header-cell *matHeaderCellDef>Client</mat-header-cell>
      <mat-cell *matCellDef="let scan">{{scan.client}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="districtCode">
      <mat-header-cell *matHeaderCellDef>district</mat-header-cell>
      <mat-cell *matCellDef="let scan">{{scan.districtCode}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="schoolCode">
      <mat-header-cell *matHeaderCellDef>school</mat-header-cell>
      <mat-cell *matCellDef="let scan">{{scan.schoolCode}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="testFamily">
      <mat-header-cell *matHeaderCellDef>Test</mat-header-cell>
      <mat-cell *matCellDef="let scan">{{scan.testFamily}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="materialId">
      <mat-header-cell *matHeaderCellDef>MaterialId</mat-header-cell>
      <mat-cell *matCellDef="let scan">{{scan.materialId}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="lithocode">
      <mat-header-cell *matHeaderCellDef>lithocode</mat-header-cell>
      <mat-cell *matCellDef="let scan">{{scan.lithocode}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="pageNumber">
      <mat-header-cell *matHeaderCellDef>Page</mat-header-cell>
      <mat-cell *matCellDef="let scan">{{scan.pageNumber}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef>ID</mat-header-cell>
      <mat-cell class="custom-width" *matCellDef="let scan">
        <a #id [routerLink]="'/diagnostics/viewScanImage/' + encodeURI(scan.id)" role="button" style="cursor:pointer">{{scan.id}}</a>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="checkDigit">
      <mat-header-cell *matHeaderCellDef>CD</mat-header-cell>
      <mat-cell *matCellDef="let scan">{{scan.checkDigit}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="backsideId">
      <mat-header-cell *matHeaderCellDef>backsideId</mat-header-cell>
      <mat-cell *matCellDef="let scan">
        <a #id [routerLink]="'/diagnostics/viewScanImage/' + encodeURI(scan.backsideId)" role="button" style="cursor:pointer">{{scan.backsideId}}</a>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="inputsProcessed">
      <mat-header-cell *matHeaderCellDef>Processed</mat-header-cell>
      <mat-cell *matCellDef="let scan">{{scan.inputsProcessed}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="demographicResults">
      <mat-header-cell *matHeaderCellDef>Demo.<br />Results</mat-header-cell>
      <mat-cell *matCellDef="let scan; let i = index">
        <button mat-button ecaThrottleClick (throttleClick)="openDialog('Demographic Results',
        JSON.stringify(scan.demographicResults, null, 2));">View</button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="inputResults">
      <mat-header-cell *matHeaderCellDef>Input Results</mat-header-cell>
      <mat-cell *matCellDef="let scan; let i = index">
        <button mat-button ecaThrottleClick (throttleClick)="openDialog('Input Results',
        JSON.stringify(scan.inputResults, null, 2));">View</button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="generateDebugImage">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let scan; let even=even;">
        @if (even) {
          <button
            mat-button
            matTooltip="Generate Debug Images"
            class="icon"
            ecaThrottleClick (throttleClick)="generateDebugImages(scan.id, scan.backsideId)">
            <mat-icon>bug_report</mat-icon>
          </button>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="debugImages">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let scan;">
        <button mat-button
          matTooltip="View Debug Images"
          class="icon"
          ecaThrottleClick (throttleClick)="debugImages(scan.id)">
          <mat-icon>photo</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="scanColumnsToDisplay"></mat-header-row>
    <mat-row *matRowDef="let scan; columns: scanColumnsToDisplay"></mat-row>
  </mat-table>
</div>
